import { SEARCH_INDEX_URL } from '@constants/config';
import { normalizeSearchIndex } from './searchModel';

export async function fetchSearchIndex({
  fetchImpl = globalThis.fetch,
  indexUrl = SEARCH_INDEX_URL,
  signal
} = {}) {
  if (typeof fetchImpl !== 'function') {
    throw new Error('Fetch is not available');
  }

  const response = await fetchImpl(indexUrl, { signal });

  if (!response.ok) {
    throw new Error(`Failed to load search index: ${response.status}`);
  }

  return normalizeSearchIndex(await response.json());
}
